import fetchAPI from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import { convertFiltersToV5Format } from '../../utils/filterFormatConversionToV5';
import store from '../store';
import { enqueueSnackbar } from './snackbar';

export const listUserBugs =
  (payload) =>
    (dispatch) => {
      const { userBugs } = store.getState();
      dispatch({
        type: REDUX_ACTIONS.USER_BUGS_LIST_LOADING,
      });

      const body = {
        input: {
          searchValue: payload?.userEmailTerm ? payload?.userEmailTerm : userBugs?.searchKey || '',
          startDate: payload?.selectedStartDateTime ? payload?.selectedStartDateTime : userBugs?.startDate || '',
          endDate: payload?.selectedEndDateTime ? payload?.selectedEndDateTime : userBugs?.endDate || '',
          filters: convertFiltersToV5Format(userBugs?.filters?.items) || [],
          limit: 100,
          page: payload?.page || 1,
          linkOperator: userBugs?.filters?.logicOperator || '',
          sort: userBugs?.sort || null
        }
      };

      const path = 'userBugs/fetch';
      return fetchAPI
        .post(path, body)
        .then((resp) => {
          if (!resp.ok) {
            return Promise.reject(resp);
          }
          return resp.json();
        })
        .then((data) => {
          dispatch({
            type: REDUX_ACTIONS.USER_BUGS_LIST_SUCCESS,
            payload: {
              data: data.data.data,
              paginatedElements: data.data.count,
              totalCount: data.data.count
            },
          });
        })
        .catch(async (error) => {
          const errorMessage = await parseError(error);

          dispatch(
            enqueueSnackbar(
              errorMessage,
              'error',
              new Date().getTime() + Math.random()
            )
          );
          dispatch({
            type: REDUX_ACTIONS.USER_BUGS_LIST_ERROR,
            payload: { ...error, message: errorMessage },
          });
        });
    };

export const downloadUserBugAttachments =
  (bugId, issue, setDownloading) =>
    (dispatch) => {
      const body = {
        query: {
          _id: bugId
        }
      };

      const path = 'userBugs/attachments';
      return fetchAPI
        .downloadPost(path, body)
        .then((result) => {
          if (!result.ok) {
            return Promise.reject(result);
          }
          return result.blob();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const fileName = `${issue}_${bugId}.zip`;

          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          dispatch(
            enqueueSnackbar(
              'Attachment Downloaded Successfully.',
              'success',
              new Date().getTime() + Math.random()
            )
          );
          setDownloading(false);
        })
        .catch(async (error) => {
          const errorMessage = await parseError(error);

          dispatch(
            enqueueSnackbar(
              errorMessage,
              'error',
              new Date().getTime() + Math.random()
            )
          );
          setDownloading(false);
        });
    };

export const updateBugReport =
(body, onCloseClick) =>
  (dispatch) => {
    const path = 'userBugs/updateStatus';
    return fetchAPI
      .put(path, body)
      .then((resp) => {
        if (!resp.ok) {
          return Promise.reject(resp);
        }
        return resp.json();
      })
      .then(() => {
        onCloseClick();
        dispatch(listUserBugs());
        dispatch(
          enqueueSnackbar(
            'Bug Progress Updated Successfully.',
            'success',
            new Date().getTime() + Math.random()
          )
        );
      })
      .catch(async (error) => {
        const errorMessage = await parseError(error);

        dispatch(
          enqueueSnackbar(
            errorMessage,
            'error',
            new Date().getTime() + Math.random()
          )
        );
      });
  };
